import { Menu, MenuItem } from '@material-ui/core';
import { SIZES } from 'common/constants/sizes';
import styled from 'styled-components';

export const StyledFilterSetMenu = styled(Menu)``;

export const StyledMenuItem = styled(MenuItem)`
  padding: 1rem 2rem;
  font-size: ${SIZES.medium};
  display: flex;
  gap: 1rem;
  line-height: 0;
`;

export const StyledMenuHeader = styled(StyledMenuItem)`
  margin-top: 1rem;
  padding-top: 2rem;
  border-top: 1px solid #d9d9d9 !important;
  margin-bottom: 1rem;
  text-transform: uppercase;
  font-weight: bold !important;
  font-size: ${SIZES.normal};
  cursor: default;
  :hover {
    background-color: transparent;
  }
`;
